document.addEventListener("DOMContentLoaded", () => {
  // Lazy-load videos: transfer `data-src` -> `src` when video becomes visible,
  // call `load()` and autoplay if muted. This prevents browsers from
  // fetching video resources before the user scrolls near them.
  function initLazyVideos() {
    const videos = document.querySelectorAll('video.lazy-video');
    if (!videos || videos.length === 0) return;

    const loadVideo = (video) => {
      const sources = video.querySelectorAll('source[data-src]');
      let hasSrc = false;
      sources.forEach((s) => {
        if (s.dataset && s.dataset.src) {
          s.src = s.dataset.src;
          hasSrc = true;
        }
      });
      if (hasSrc) {
        try { video.load(); } catch (e) {}
      }
      // If muted and not an lp-video section item, attempt autoplay on load/visible.
      // .lp-video should show controls and not autoplay.
      if (video.muted && !video.closest('.lp-video')) {
        video.play().catch(() => {});
      }
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });

      videos.forEach(v => io.observe(v));
    } else {
      // Fallback: load all immediately
      videos.forEach(loadVideo);
    }
  }

  initLazyVideos();

  // Pause .lp-video players when switching between PC and Mobile
  const mql = window.matchMedia("(max-width: 1149px)");
  mql.addEventListener("change", (e) => {
    if (e.matches) {
      document.querySelectorAll('.lp-video__player--pc').forEach(v => v.pause());
    } else {
      document.querySelectorAll('.lp-video__player--mobile').forEach(v => v.pause());
    }
  });

  const gsap = window.gsap;
  const ScrollTrigger = window.ScrollTrigger;

  if (!gsap || !ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  // Screen 1: Hero
  const heroTl = gsap.timeline({
    scrollTrigger: {
      trigger: ".lp-hero",
      start: "top top",
      end: "+=250%",
      pin: true,
      scrub: 1,
    }
  });

  heroTl.fromTo(".lp-hero__text--1", { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1 })
        .fromTo(".lp-hero__text--2", { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1 })
        .fromTo(".lp-hero__text--3", { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1 })
        .to(".lp-hero", { opacity: 0, duration: 1, delay: 1 });

  // Screen 2: Timeline Fade In Overlay
  const timelineTl = gsap.timeline({
    scrollTrigger: {
      trigger: ".lp-timeline",
      start: "top 70%",
      end: "top top",
      scrub: 1
    }
  });

  timelineTl.to(".lp-timeline", { opacity: 1 });

  // Screen 2: Timeline Nodes
  const events = gsap.utils.toArray(".lp-timeline__event");
  events.forEach((event) => {
    gsap.fromTo(event, 
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        scrollTrigger: {
          trigger: event,
          start: "top 85%",
          end: "top 60%",
          scrub: 1
        }
      }
    );
  });

  // Screen 2: Timeline Ending
  const timelineEndingTl = gsap.timeline({
    scrollTrigger: {
      trigger: ".lp-timeline",
      start: "bottom bottom",
      end: "+=300%",
      pin: true,
      scrub: 1,
    }
  });

  timelineEndingTl.to(".lp-timeline__wrapper", {
    clipPath: "inset(50% 50% 50% 50%)",
    opacity: 0,
    duration: 2
  })
  .to(".lp-timeline__ending", {
    opacity: 1,
    scale: 1.2,
    duration: 1.5
  }, "-=1")
  .to({}, { duration: 1.5 }) // Pause duration to hold text on screen
  .to(".lp-timeline", {
    opacity: 0,
    duration: 1
  });

  // Screen 3: Video
  gsap.to(".lp-video", {
    opacity: 1,
    scrollTrigger: {
      trigger: ".lp-video",
      start: "top 70%",
      end: "top top",
      scrub: 1
    }
  });

  // Media with text animations
  const mediaBlocks = gsap.utils.toArray(".ky-media-with-text__block");
  mediaBlocks.forEach((block) => {
    // Image fade in
    const img = block.querySelector(".ky-media-with-text__anim-img");
    if (img) {
      gsap.fromTo(img, 
        { opacity: 0 },
        {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: block,
            start: "top 75%",
          }
        }
      );
    }

    // Texts slide up with stagger
    const texts = block.querySelectorAll(".ky-media-with-text__anim-up");
    if (texts.length > 0) {
      gsap.fromTo(texts, 
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          scrollTrigger: {
            trigger: block,
            start: "top 65%",
          }
        }
      );
    }
  });
});